import { Col, Container, Row, Button, Card, CardBody, CardHeader } from "reactstrap";
import { Link } from 'react-scroll';
import logoSoal from '../../../assets/images/game/w2_assets/Questionbar.png'
import Pilihan1 from '../../../assets/images/game/w2_soal/no-5/FOTO-HOAKS-PFIZER-1.png'

import AnswerTrue from '../../../assets/images/game/w2_soal/NO 6 (TEKNIK SEDERHANA)/no-6-answer.png'
import AnswerFalse from '../../../assets/images/game/w2_soal/NO 6 (TEKNIK SEDERHANA)/no-6-answer.png'
import { useContext, useState } from "react";
import { Context } from "../../../contexts/reducer/store";
import CheckAnswer from "../CheckAnswer";

import hiasan21 from '../../../assets/images/game/w2_assets/AdkBQM-full.png'
import hiasan22 from '../../../assets/images/game/w2_assets/Asset-69.png'
import hiasan23 from '../../../assets/images/game/w2_assets/Asset-68.png'
import hiasan24 from '../../../assets/images/game/w2_assets/Asset-77.png'
import Left from '../../../assets/images/game/w2_assets/question-title-left.png';
import Right from '../../../assets/images/game/w2_assets/question-title-right.png';


const Soal6 = () => {
    
    let [isOpen, setIsOpen] = useState(false)
    let [isTrue, setIsTrue] = useState(false)

    const [state, dispatch] = useContext(Context);
    const [disabled, setDisabled] = useState(false)

    function toggleModal ( type ) {
        setIsOpen(!isOpen);
        setIsTrue(type);
        setDisabled(true)
    }

    function SET_MARK ( value = Number ) {
        const init = {...state};
        let __mark = init.mark
        dispatch({type: 'SET_MARK', payload: __mark + value});
    }

    const Answer = () => {
        return (
            <>
                <div className={`text-center`}>
                    {
                        isTrue 
                        ? (
                            <><small>Berikut Penjelasan selengkapnya :</small></>    
                        ) 
                        : (
                            <><small>Berikut ini jawaban teknik riset yang benar :</small></>
                        )
                    }
                </div>
                <img className="img-fluid" src={isTrue ? AnswerTrue : AnswerFalse} alt="" />
                <div className={`bg-light-green text-center py-1 ${isTrue ? 'd-none' : 'd-block'} my-3`}>
                    Jawaban yang benar pada soal adalah <b>4, 2 dan 1.</b>
                </div>
            </>
        )
    }

    return (
        <>
            <Container className="container front">
                <CheckAnswer Type={isTrue} isOpen={isOpen} setIsOpen={setIsOpen}>
                    <Answer />
                </CheckAnswer>
                <Row>
                    <Col md="12" className="text-center game-px">
                        <Row className="mb-5">
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Left} alt="" />
                            </Col>
                            <Col lg="10" md="10" sm="10" xs="10" className="my-auto">
                                <Card className="card-title-quiz">
                                    <CardBody>
                                        <h2 className="judul-game-4 montserrat">
                                            TIPS <b>IDENTIFIKASI KLAIM HOAKS</b> LAINNYA <b>YANG <br />BISA DITERAPKAN</b> ADALAH...
                                        </h2>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Right} alt="" />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md="12">
                                <Card className="card-game">
                                    <CardBody>
                                        <Row>
                                            <Col md="6" className="">
                                                <div className="p-4">
                                                    <img src={Pilihan1} alt="Klaim Hoaks" className="w-100" />
                                                </div>
                                            </Col>
                                            <Col md="6" className="pt-5">
                                                <span className="judul-pilihan-soal-2">PILIHAN TEKNIK RISET:</span>
                                                <div className="pt-4">
                                                    <ol className="desc-soal6 montserrat text-start">
                                                        <li className="pt-4">Gunakan tools (Yandex, dll)</li>
                                                        <li className="pt-4">Tanya pada ahli kesehatan</li>
                                                        <li className="pt-4">Gunakan sumber anonim jadi acuan</li>
                                                        <li className="pt-4">Cek headline klaim </li>
                                                        <li className="pt-4">Cek penulis dan sumber</li>
                                                        <li className="pt-4">Langsung mempercayai isi klaim</li>
                                                    </ol>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            disabled === false
                            ? <Row className="pt-3">
                                    <Col md="4" className="mx-auto text-center pt-3 p-0">
                                        <Link to="q7" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>4, 6, DAN 3</Link >
                                    </Col>
                                    <Col md="4" className="mx-auto text-center pt-3 p-0">
                                        <Link to="q7" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>1, 6, DAN 5</Link >
                                    </Col>
                                    <Col md="4" className="mx-auto text-center pt-3 p-0">
                                        <Link to="q7" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(true), SET_MARK(1))}>4, 2, DAN 1</Link >
                                    </Col>
                                </Row>
                            : <Row className="pt-3">
                                    <Col md="4" className="mx-auto text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>4, 6, DAN 3</button >
                                    </Col>
                                    <Col md="4" className="mx-auto text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>1, 6, DAN 5</button >
                                    </Col>
                                    <Col md="4" className="mx-auto text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>4, 2, DAN 1</button >
                                    </Col>
                                </Row>
                        }
                    </Col>
                </Row>
            </Container>
            <div className="position-relative img-asset">
                <img src={hiasan21} className="asset-21" />
                <img src={hiasan22} className="asset-22" />
                <img src={hiasan23} className="asset-23" />
                <img src={hiasan24} className="asset-24" />
            </div>
        </>
    )
}

export default Soal6